var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-content"},[_c('div',{staticClass:"index-container"},[_c('div',{staticClass:"index-main"},[_vm._m(0),_c('button',{staticClass:"back-home",on:{"click":_vm.backHome}},[_vm._v("返回首页")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-message"},[_c('img',{attrs:{"src":require("@/assets/images/finished.svg"),"alt":"success"}}),_c('p',[_vm._v("恭喜您，文章发布成功！")])])
}]

export { render, staticRenderFns }